<p-paginator [rows]="pagination?.per_page"
             [totalRecords]="pagination?.total"
             [first]="pagination?.per_page * (pagination?.current_page - 1)"
             [showFirstLastIcon]="showFirstLastIcon"
             (onPageChange)="changePage?.emit($event?.page)">
</p-paginator>
